import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { AddressApi } from './PersonAddressApi';
import { PhoneApi } from './PersonPhoneApi';
import { AnredeArtApi } from './InterfacesAnredeArtApi';

/**
 * APIL Url: ADAC.Internet.Core.Models.Mitgliedschaft.Antragssteller
 * Antragssteller einer Mitgliedschaftsanlage
 * Endpoints: /api/v2/versicherungen/fahrrad/anlage, /api/v2/versicherungen/fahrrad/angebot, /api/v2/versicherungen/fahrrad/angebotlesen, /api/haustier/anlage, /api/haustier/angebot, /api/haustier/angebotlesen, /api/mitgliedschaft, /api/mitgliedschaft/younggeneration, /api/mitgliedschaft/check24, /api/mitgliedschaft/check24ev, /api/mitgliedschaft/finanzdienste/kreditkarte, /api/mitgliedschaft/finanzdienste/modulkreditkarte, /api/mitgliedschaft/finanzdienste/autokredit, /api/mitgliedschaft/versicherungen/auto, /api/mitgliedschaft/profiwerber/agw, /api/ps/anlage, /api/rrv/anlage, /api/rrv/anlageextern, /api/rrv/angebot, /api/us/anlage, /api/us/angebot, /api/versicherungen/aksbep/anlage, /api/versicherungen/aks/anlageextern, /api/versicherungen/akslangzeit/anlage, /api/versicherungen/incoming/anlage, /api/versicherungen/brs/anlage, /api/versicherungen/phv/anlage, /api/versicherungen/us/anlage, /api/versicherungen/ps/anlage, /api/versicherungen/brs/angebot, /api/versicherungen/us/angebot, /api/versicherungen/aks/angebot, /api/versicherungen/akslangzeit/angebot, /api/versicherungen/brs/leseangebot, /api/versicherungen/us/leseangebot, /api/versicherungen/aks/leseangebot, /api/versicherungen/akslangzeit/leseangebot, /api/v2/versicherungen/rrv/anlage, /api/v2/versicherungen/rrv/anlageextern, /api/v2/versicherungen/rrv/angebot, /api/v2/versicherungen/rrv/leseangebot, /api/zuhause/hausrat/anlage, /api/zuhause/hausrat/angebot, /api/zuhause/hausrat/angebotlesen, /api/zuhause/schutzbrief/anlage, /api/zuhause/schutzbrief/angebot, /api/zuhause/schutzbrief/angebotlesen
 */
export class AntragsstellerApi extends BaseApiModel {
	constructor(initialProperties?: Partial<AntragsstellerApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected anschrift: AddressApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Address
	 */
	get Anschrift(): AddressApi {
		return this.anschrift;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Address
	 */
	set Anschrift(value: AddressApi) {
		this.anschrift = value;
	}

	protected telefon: PhoneApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Phone
	 */
	get Telefon(): PhoneApi {
		return this.telefon;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Phone
	 */
	set Telefon(value: PhoneApi) {
		this.telefon = value;
	}

	protected telGesch: PhoneApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Phone
	 */
	get TelGesch(): PhoneApi {
		return this.telGesch;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Phone
	 */
	set TelGesch(value: PhoneApi) {
		this.telGesch = value;
	}

	protected email: string;
	/**
	 * Description: E-Mail-Adresse des Antragsstellers
	 * APIL Type: string
	 */
	get Email(): string {
		return this.email;
	}

	/**
	 * Description: E-Mail-Adresse des Antragsstellers
	 * APIL Type: string
	 */
	set Email(value: string) {
		this.email = value;
	}

	protected anrede: AnredeArtApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Interfaces.AnredeArt
	 */
	get Anrede(): AnredeArtApi {
		return this.anrede;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Interfaces.AnredeArt
	 */
	set Anrede(value: AnredeArtApi) {
		this.anrede = value;
	}

	protected firma: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Firma(): string {
		return this.firma;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Firma(value: string) {
		this.firma = value;
	}

	protected titel: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Titel(): string {
		return this.titel;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Titel(value: string) {
		this.titel = value;
	}

	protected vorname: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Vorname(): string {
		return this.vorname;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Vorname(value: string) {
		this.vorname = value;
	}

	protected nachname: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Nachname(): string {
		return this.nachname;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Nachname(value: string) {
		this.nachname = value;
	}

	protected beguenstigter: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Beguenstigter(): string {
		return this.beguenstigter;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Beguenstigter(value: string) {
		this.beguenstigter = value;
	}

	protected geburtsdatum: string;
	/**
	 * Description: 
	 * APIL Type: date-time
	 */
	get Geburtsdatum(): string {
		return this.geburtsdatum;
	}

	/**
	 * Description: 
	 * APIL Type: date-time
	 */
	set Geburtsdatum(value: string) {
		this.geburtsdatum = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): AntragsstellerApi {
		return AppUtils.Helper.createFromMap(dataObject, AntragsstellerApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'anschrift':
					return AddressApi.createFromObject(value);
				case 'telefon':
					return PhoneApi.createFromObject(value);
				case 'telgesch':
					return PhoneApi.createFromObject(value);
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		if (this.anschrift) {
			result.Anschrift = this.anschrift.toRequestObject();
		}
		if (this.telefon) {
			result.Telefon = this.telefon.toRequestObject();
		}
		if (this.telGesch) {
			result.TelGesch = this.telGesch.toRequestObject();
		}
		result.Email = this.email;
		result.Anrede = this.anrede;
		result.Firma = this.firma;
		result.Titel = this.titel;
		result.Vorname = this.vorname;
		result.Nachname = this.nachname;
		result.Beguenstigter = this.beguenstigter;
		result.Geburtsdatum = this.geburtsdatum;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}